'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _toggleClass = require('helpers/toggleClass');

var _toggleClass2 = _interopRequireDefault(_toggleClass);

var _EditorComponentWrapper = require('./EditorComponentWrapper.scss');

var _EditorComponentWrapper2 = _interopRequireDefault(_EditorComponentWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorComponentWrapper = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(EditorComponentWrapper, _Component);

  function EditorComponentWrapper() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EditorComponentWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EditorComponentWrapper.__proto__ || (0, _getPrototypeOf2.default)(EditorComponentWrapper)).call.apply(_ref, [this].concat(args))), _this), _this._onMouseOver = function (event) {
      if (!_this.props.isSelectable) return;
      if (!_this.props.propagate) event.stopPropagation();
      (0, _toggleClass2.default)((0, _reactDom.findDOMNode)(_this), _EditorComponentWrapper2.default['wrapper--hovered']);
    }, _this._onMouseOut = function (event) {
      if (!_this.props.isSelectable) return;
      if (!_this.props.propagate) event.stopPropagation();
      (0, _toggleClass2.default)((0, _reactDom.findDOMNode)(_this), _EditorComponentWrapper2.default['wrapper--hovered']);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EditorComponentWrapper, [{
    key: 'render',
    value: function render() {
      var _cx;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          isSelectable = _props.isSelectable,
          isSelected = _props.isSelected;


      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)(className, _EditorComponentWrapper2.default.wrapper, (_cx = {}, (0, _defineProperty3.default)(_cx, _EditorComponentWrapper2.default['wrapper--selectable'], isSelectable), (0, _defineProperty3.default)(_cx, _EditorComponentWrapper2.default['wrapper--selected'], isSelected), _cx)),
          onMouseOver: this._onMouseOver,
          onMouseOut: this._onMouseOut
        },
        children
      );
    }
  }]);
  return EditorComponentWrapper;
}(_react.Component), _class.propTypes = {
  propagate: _react.PropTypes.bool,
  isSelectable: _react.PropTypes.bool,
  isSelected: _react.PropTypes.bool,
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
}, _class.defaultProps = {
  propagate: false,
  isSelectable: true,
  isSelected: false
}, _temp2);
exports.default = EditorComponentWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/common/EditorComponentWrapper/EditorComponentWrapper.jsx
// module id = 1563
// module chunks = 0